module.exports = __webpack_public_path__ + "static/media/jungle.c3e41321.jpg";